import { forwardPropsToState } from 'utils/react_utils';

const RealizeCustom = {
	InputAutocomplete: window.InputAutocomplete,
	InputAutocompleteSelect: window.InputAutocompleteSelect
};

@forwardPropsToState([
	{ prop: 'value', defaultValue: [] },
	{ prop: 'options', defaultValue: [] },
	{ state: 'optionsCache', prop: 'options', defaultValue: [] },
])
export default class InputAutocomplete extends RealizeCustom.InputAutocomplete {

	static defaultProps = {
		...RealizeCustom.InputAutocomplete.defaultProps,
		inputAutoCompleteSelectComponent: RealizeCustom.InputAutocompleteSelect
	};

	constructor(props) {
		super(props);
		this.selectedOptions = InputAutocomplete.prototype.selectedOptions.bind(this);
		this.handleSelect = InputAutocomplete.prototype.handleSelect.bind(this);
		this.handleClear = InputAutocomplete.prototype.handleClear.bind(this);
		this.hideResult = InputAutocomplete.prototype.hideResult.bind(this);
	}

	clearButtonEvent(){
		$('.input-autocomplete__clear-button').attr('tabindex', 0).unbind('focus').focus((e) => {
			setTimeout(()=>{
				$(e.currentTarget).css({border: '1px solid'});
			},0);			
		}).unbind('blur').blur((e) => {
			setTimeout(()=>{
				$(e.currentTarget).css({border: 'none'});
			},0);			
		});
	}

	customShowResult(){		

		setTimeout(() => {
			$("#boxSearch__redirect").css({display: 'flex'});
			$("#caret_redirect").hide();
		}, 200)

		setTimeout(() => {
			$("#input_redirect").focus();
		}, 300)
	}

	hideResult() {
		$("#boxSearch__redirect").hide();
		$("#caret_redirect").show();

		this.state.loadParams[this.props.searchParam] = '';

		this.setState({
			active: 0,
			searchValue: '',
			value: ''
		});
	}

	handleDocClick(event){
		const elem = $("#boxSearch__redirect");
		if (elem.is(":visible") && event.target.id !== "caret_redirect_p" && event.target.id !== "autocomplete_select" && event.target.id !== "caret_redirect") {
			this.hideResult();
		}
	}

	getResultComponent() {
		return this.refs.result;
	}

	componentDidMount() {
		if(this.props.optionsUrl) {
			if(!!this.props.dependsOn) {
				this.listenToDependableChange();
				this.loadDependentOptions(null, true);
			} else {
				this.loadOptions();
			}
		}

		if(this.state.value.length > 0) {
			this.triggerDependableChanged();
		}
	}

	render() {
		return (
			<div className={this.className()} ref="container">
			{this.renderInputAutcompleteSelect()}
			{this.renderInputAutocompleteResult()}
			{this.renderInputAutocompleteValues()}
			</div>
		);
	}

	handleOnKeyUpReadonly(e){
		if(e.keyCode === 32 || e.keyCode === 13){
			this.customShowResult.bind(this)(e);
		}
	}

	getValueSelected(){
		const list = this.selectedOptions();
		return (list && list.length > 0) ? list[0].name : (this.state.newValue && this.state.newValue.name) ? this.state.newValue.name : '';
	}

	renderInputAutcompleteSelect() {

		return(
			<div className="select-wrapper initialized">
				<span className="caret" 
				id={"caret_redirect"}
				onClick={this.customShowResult.bind(this)}
				onKeyUp={this.handleOnKeyUpReadonly.bind(this)}	
				aria-disabled={this.props.disabled}							
				aria-label={`${this.getValueSelected() !== '' ? Realize.i18n.t("general.options_selected").replace('@', this.getValueSelected()) : Realize.i18n.t("general.not_options_selected")} - ${Realize.i18n.t("general.open_options").replace('@', this.props.label || '')}`}
				tabIndex={(this.props.disabled || this.props.readOnly) ? -1 : 0}><p id={"caret_redirect_p"} aria-hidden={true}>▼</p></span>

				<input id="autocomplete_select" 
				placeholder="Selecione" 
				type="text" 
				tabIndex="-1"				
				autoComplete="off"
				value={this.getValueSelected()}
				onClick={this.customShowResult.bind(this)}
				onFocus={this.customShowResult.bind(this)}/>
			</div>
		)
	}

	handleChange(event){
		var newValue = event.target.value;
		this.searchOptions(event, newValue, this);
		
		if (!event.isDefaultPrevented()) {
			this.setState({ value: newValue});
		}
	}

	handleClick(item, e){
		this.handleSelect.bind(this)(e, item);
	}

	handleOnKeyDown(item, e){
		if(e.keyCode === 13){
			this.handleClick(item, e);
		}
	}

	renderListLI(){
		const result = this.getResultOptions();
		return result.map((item, i) => {
			return <li   
						onKeyDown={this.handleOnKeyDown.bind(this, item)}
						onBlur={this.handleOnBlur.bind(this)}
						onClick={this.handleClick.bind(this, item)}
						className={`input-autocomplete__option`}
						style={{borderBottom: '1px solid #cccccc'}}
						aria-label={Realize.i18n.t('general.search.options').replace('@', item.name).replace('#', i + 1).replace('&', result.length)}
						tabIndex={0}
						>
						{(this.getValueSelected().trim() === item.name) && <Icon type="done" class="material-icons prefix" style={{position: 'relative', top: '7px', left: '-6px'}}/>}
						<span aria-hidden="true">{item.name}</span>
					</li>		
		});	
	}

	renderButtonClear(){
		return(
			<div style={{borderBottom: '1px solid rgba(0, 0, 0, 0.2)'}}>
				<button 
					id={'redirect_clear_button'}
					style={{ 
						background: "transparent",
						border: "none", 
						color: "rgb(3, 155, 229)"
					}} 
					className="input-autocomplete__clear-button" 
					tabindex="0" 
					onClick={this.handleClear.bind(this)}
				>
					{Realize.i18n.t("inputs.autocomplete.clear")}
				</button>
			</div>
		);
	}

	renderInputAutocompleteResult() {
		const result = this.getResultOptions();
		
		setTimeout(()=>{
			this.clearButtonEvent();
			$(document).unbind('click').on('click', this.handleDocClick.bind(this));
		},0);
		
		return(
			<div id="boxSearch__redirect" className="input-autocomplete__result z-depth-1" style={{display: "none", flexDirection: 'column', position: (result.length > 4 ? "relative" : "absolute"), top: (result.length > 4 ? "-85px" :"40px")}}>
				<div className="input-autocomplete__search">
					<i className="material-icons prefix" data-position="top" data-delay="10" type="search" aria-hidden="true">search</i>
					<input 
					id={"input_redirect"}
					value={this.state.searchValue}					
					onBlur={this.handleOnBlur.bind(this)}
					onChange={this.handleChange.bind(this)} 
					autoComplete="off"
					type="text"/>
				</div>
				{this.renderButtonClear()}
				{(result && result.length > 0) &&
					<ul id={`result_list`} className={'input-autocomplete__list'}>
						{this.renderListLI()}						
					</ul>
				}

				{(result && result.length === 0) &&
					<div id={"result_empty_message"} className="input-autocomplete__empty-message" tabIndex="0" onBlur={this.handleOnBlur.bind(this)}>{Realize.i18n.t("general.empty_result_list")}</div>
				}
			</div>
		)  

	}

	browser (agent) {
		switch(true){
			case agent.indexOf("edge") > -1: return "edge";
			case agent.indexOf("opr") > -1 && !!window.opr: return "opera";
			case agent.indexOf("chrome") > -1 && !!window.chrome: return "chrome";
			case agent.indexOf("trident") > -1: return "ie";
			case agent.indexOf("firefox") > -1: return "firefox";
			case agent.indexOf("safari") > -1: return "safari";
			default: return "other";
		}
	}	

	handleOnBlur(e) {

		const userAgent = this.browser(window.navigator.userAgent.toLowerCase());

		if(userAgent === 'ie') {
			if((e.currentTarget.id === 'autocomplete_select' || e.currentTarget.id === 'input_redirect') || (e.currentTarget.tagName === "LI")){
				if(document.activeElement.tagName === "P" || document.activeElement.tagName === "SPAN" || (document.activeElement.tagName === "BUTTON" && document.activeElement.id !== "redirect_clear_button")){
					this.hideResult();
				}
				return false;
			}
		}
		
		if((e.nativeEvent.relatedTarget && e.nativeEvent.relatedTarget.id === "redirect_clear_button") || 
		(e.nativeEvent.relatedTarget && e.nativeEvent.relatedTarget.tagName === "LI") || 
		(e.currentTarget && e.currentTarget.tagName === "LI" && e.nativeEvent.relatedTarget && e.nativeEvent.relatedTarget.tagName !== "BUTTON")){
			return false;
		}

		if(e.currentTarget && e.currentTarget.id === "result_empty_message" && e.nativeEvent.relatedTarget && e.nativeEvent.relatedTarget.id !== "redirect_clear_button"){
			this.hideResult();
		}else{
			this.hideResult();
		}
	}

	renderInputAutocompleteValues() {
		return (
			<InputAutocompleteValues
				id={this.props.id}
				name={this.props.name}
				multiple={this.props.multiple}
				selectedOptions={this.selectedOptions()}
				ref="select" />
		);
	}

	selectedOptions() {
		const valueSelected = this.state.newValue || this.state.value;
		const value = this.ensureIsArray(valueSelected).map(val => val);
		const list = this.state.optionsCache.length > 0 ? this.state.optionsCache : this.state.list ? this.state.list : [];
		return list.filter(option => value.includes(option.value));
	}

	handleClear() {
		this.setState({
			value: [],
			newValue: undefined,
			list: []
		}, () => {
			this.triggerDependableChanged();
			this.props.onChange(null, [], this);
		});

		if(!this.props.multiple) {
			this.hideResult();
		}

		if(!!this.props.onSelect) {
			this.props.onSelect(this.props.id, [], []);
		}
	}

	handleSelect(event, option) {
		let value = this.ensureIsArray(this.state.value);		

		if (!value.includes(option.value)) {
			if (!this.props.multiple) value = [];
			value.push(option.value);
		} else {
			let indexValue = value.indexOf(option.value);
			if (indexValue > -1) value.splice(indexValue, 1);
		}

		this.forceUpdate();
		this.triggerDependableChanged();

		if(!this.props.multiple)
		this.hideResult();

		if(!!this.props.onSelect)
		this.props.onSelect(this.props.id, value, this.state.loadData);

		this.props.onChange(event, value, this);
		this.setState({ newValue: option, value, list: this.state.optionsCache });
	}

}
